export const PER_DAY = 'Per Day';
//export const WEEKLY = 'Weekly';
export const MONTHLY = 'Per Month';
//export const QUARTERLY = 'Quarterly';
//export const ANNUALLY = 'Annually';

export const FREQUENCY = [
	{ label: PER_DAY, value: PER_DAY },
	{ label: MONTHLY, value: MONTHLY },
];
